import { Issuers } from '@/constants/issuers';

import type { TokenResult } from './token-registry.types';

const RWA_TOKEN_LIST_NAME = 'RWA Tokens';

const RWA_TOKEN_LIST_EXEMPT_ISSUERS = new Set<string>([
  Issuers.XSTOCKS,
  Issuers.ROBINHOOD,
  Issuers.ONDO,
]);

/** Whether a token remains blocked after applying supported RWA issuer exceptions. */
export const isTokenBlockedByTokenList = (
  token: Pick<TokenResult, 'issuer' | 'tokenListsBlock'> | undefined,
): boolean => {
  if (!token?.tokenListsBlock?.length) return false;

  const isIssuerExempt = RWA_TOKEN_LIST_EXEMPT_ISSUERS.has(token.issuer?.name.toLowerCase() ?? '');
  if (!isIssuerExempt) return true;

  return token.tokenListsBlock.some(({ name }) => name !== RWA_TOKEN_LIST_NAME);
};
